import styled from "styled-components";

export default styled.br`
    margin-bottom: 12px;
`
